import { render, staticRenderFns } from "./SettingAccountMailConfig.vue?vue&type=template&id=504a7f32"
import script from "./SettingAccountMailConfig.vue?vue&type=script&lang=js"
export * from "./SettingAccountMailConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports